import React from 'react';
import { FilterConfig, FilterType } from '../types';
import { isSelectType } from './filterChipUtils';
import { FilterChip } from './FilterChip';
import { SelectFilterChip } from './SelectFilterChip';
import { TreeFilterChip } from './TreeFilterChip';

interface Props {
  conf: FilterConfig;
  filter: any;
  applyFilterValue: (key: string, value: any) => void;
  loading: boolean;
  /** Open the editor automatically on mount (used for chips just added via "Add filter"). */
  autoOpen?: boolean;
  /** Called when the editor closes; `active` reflects whether a value ended up set. */
  onClosed?: (active: boolean) => void;
  /** Let the chip's value wrap to multiple lines instead of truncating (used in the "All filters" sidebar). */
  wrap?: boolean;
  /** Hide the field label inside the chip; inactive chips show a "Not selected" placeholder instead. */
  hideLabel?: boolean;
}

/**
 * Single entry point for rendering a filter chip — picks TreeFilterChip for two-level trees,
 * SelectFilterChip for select-style filters and FilterChip for the rest. Shared by the filter bar and
 * the "All filters" sidebar so both render identical chips with identical behaviour.
 */
export const FilterChipControl: React.FC<Props> = props => {
  if (props.conf.filterType === FilterType.TreeMultiSelect) return <TreeFilterChip {...props} />;
  const Comp = isSelectType(props.conf) ? SelectFilterChip : FilterChip;
  return <Comp {...props} />;
};